import styled from 'styled-components';

export const ZoomableContainerStyled = styled.div`
  overflow: auto;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  justify-items: center;
  align-items: center;

  .ZoomableContainerPosition {
    position: relative;
    overflow: hidden;

    .ZoomableContainerZoom {
      transform-origin: top left;
      display: inline-block;
    }
  }
`;

export default ZoomableContainerStyled;